// extracted by mini-css-extract-plugin
module.exports = {"modal-list-flexbox":"Modal-module__modal-list-flexbox___VxPQG"};